<template>
  <el-dialog class="dialog-simple" :visible.sync="visible" title="详情" width="1200px" :close-on-click-modal="false" :close-on-press-escape="false">
    <div class="detail-content">
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DetailDialog',
  data () {
    return {
      btnSize: 'small',
      dialogLoading: false,
      visible: false,
      dataForm: {}
    }
  },
  computed: {
  },
  methods: {
    init (row) {
      this.visible = true
      this.$nextTick(() => {
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
